<div class="container pointer" [ngClass]="{'slideUp' : isCountryChecked(country?.originalName), 'd-none': hide === true}" (click)="toggleCountry()">
  <label class="checkbox-container" [ngClass]="{ 'checked': isCountryChecked(country?.originalName) || country?.originalName === defaultValue }">
    <input type="checkbox" [(ngModel)]="checkedCountry" name="checkedCountry" />
    <span class="custom-checkbox">
      <nb-icon class="check-icon" icon="check" pack="icomoon"></nb-icon>
    </span>
  </label>
  <h6 class="pointer global-transition">{{ country?.translatedName }}</h6>
</div>
